import React from "react";

export const Footer = () =>{
    return(<footer className="d-flex align-content-center justify-content-center"></footer>);
};

export default Footer;